<template>
  <div class="typed-on-paper">
    <div style="font-family: 'Garamond'; word-spacing: 8px; letter-spacing: 2px; font-size: xx-large; text-align: center">PILOTS RECOMMENDED FOR DECORATIONS</div>
    <br>
    <template v-if="character_ids.length > 0">
      <p>The following pilots are recommended for decorations. Approval of the Commanding Officers or Adjutant
        is needed for awarding decorations.</p>
      <div
        class="container"
        v-for="character_id in character_ids">

        <template v-for="(decoration, index) in decorationsByCharacterId(character_id)">

          <div
            v-if="index == 0"
            class="heading">
            <span>{{ decoration.abreviation }}</span>
            <span>{{ decoration.first_name }} '{{ decoration.callsign }}' {{ decoration.last_name }}</span>
          </div>

          <CharacterDecorationComp
            v-bind:decoration_id="decoration.decoration_id"
            v-bind:award_name="decoration.award_name"
            v-bind:award_description="decoration.award_description"
            v-bind:awarded="decoration.awarded"
            v-bind:award_image="decoration.award_image"
          ></CharacterDecorationComp>

        </template>

      </div>
    </template>
    <template v-else>
      <p>No pilots are currently recommended for decorations.</p>
    </template>

  </div>

</template>

<script>
import {mapState, mapGetters} from "vuex"
import CharacterDecorationComp from './MemberCharacterDecorationComp'

export default {
  name: "UnitDecorationComp",
  components:{
    CharacterDecorationComp
  },
  computed: {

    character_ids: function() {

      return [...new Set(this.decorations.map(item => item.character_id))];

    },

    ...mapState("characterStore", {

      decorations: state => state.decorations,
    }),

    ...mapGetters("characterStore", [
      "decorationsByCharacterId"
    ])
  },
  methods: {

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/admin/UnitDecorationComp.vue